<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改定制采购单' : '新增定制采购单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="100px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="customerId">
          <CustomerSelect
            :value="customer"
            @select="selectCustomer"
          ></CustomerSelect>
        </el-form-item>
        <el-form-item label="定制单" prop="relatedOrderHeadId">
          <div class="fm-flex fm-rela">
            <div
              style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                cursor: pointer;
              "
              @click="toSelectOrder"
            ></div>
            <el-input
              :value="
                relatedCustomizeOrderHead && relatedCustomizeOrderHead.orderNo
                  ? relatedCustomizeOrderHead.orderNo
                  : null
              "
              :placeholder="
                relatedCustomizeOrderHead && relatedCustomizeOrderHead.orderNo
                  ? relatedCustomizeOrderHead.orderNo
                  : '请选择需要采购的单据'
              "
              style="width: 400px"
              readonly
              suffix-icon="el-icon-arrow-right"
              @click.native="toSelectOrder"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <SupplierSelect
            :value="supplier"
            @select="selectSupplier"
          ></SupplierSelect>
        </el-form-item>
        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未添加商品</span>
            <span>，总采购价：</span>
            <FmAmount :amount="headInfo.commodityRetailTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectOrderItem"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            prop="commodityName"
            label="商品信息"
            min-width="200"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content" style="max-width: 300px">
                    <p>
                      商品名称：{{
                        scope.row.relatedCustomizeOrderItem.commodityName
                      }}
                    </p>
                    <p class="fm-mt-5">
                      备注：
                      <span
                        v-fmtype="
                          scope.row.relatedCustomizeOrderItem.remark
                            ? ''
                            : 'warning'
                        "
                        >{{
                          scope.row.relatedCustomizeOrderItem.remark || "——"
                        }}</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="fm-line-2">
                      商品名称：{{
                        scope.row.relatedCustomizeOrderItem.commodityName
                      }}
                    </p>
                    <p class="fm-line-2 fm-mt-5">
                      备注：
                      <span
                        v-fmtype="
                          scope.row.relatedCustomizeOrderItem.remark
                            ? ''
                            : 'warning'
                        "
                        >{{
                          scope.row.relatedCustomizeOrderItem.remark || "——"
                        }}</span
                      >
                    </p>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingPrice"
            label="零售单价"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.relatedCustomizeOrderItem.buyingPrice"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="销售数量"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.relatedCustomizeOrderItem.itemQuantity +
                  " " +
                  scope.row.relatedCustomizeOrderItem.unit
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            label="出入库进度"
            width="170"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <div class="fm-flex">
                待入库：{{
                  scope.row.relatedCustomizeOrderItem.toBeInputQuantity
                }}，入库中：{{
                  scope.row.relatedCustomizeOrderItem.inputingQuantity
                }}
              </div>
              <div class="fm-flex">
                已入库：{{
                  scope.row.relatedCustomizeOrderItem.completedInputQuantity
                }}，待出库：{{
                  scope.row.relatedCustomizeOrderItem.toBeOutputQuantity
                }}
              </div>
              <div class="fm-flex">
                出库中：{{
                  scope.row.relatedCustomizeOrderItem.outputingQuantity
                }}，已出库：{{
                  scope.row.relatedCustomizeOrderItem.completedOutputQuantity
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="retailPrice"
            label="采购价"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 120px"
                v-model="scope.row.retailPrice"
                size="mini"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="采购数量"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                style="width: 120px"
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="mini"
                :max="scope.row.relatedCustomizeOrderItem.toBeInputQuantity"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>

          <el-table-column
            prop="commodityRetailTotalAmount"
            label="总采购价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.commodityRetailTotalAmount"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="disCountAmount"
            label="折扣金额"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="成交价"
            width="140"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 130px"
                v-model="scope.row.itemAmount"
                size="mini"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.commodityRetailTotalAmount == 'string'
                    ? Number(scope.row.commodityRetailTotalAmount)
                    : scope.row.commodityRetailTotalAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            header-align="center"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              <el-popconfirm
                title="是否删除所选商品？"
                @confirm="changeItemQuantity(scope.$index, scope.row, 0)"
              >
                <el-button
                  slot="reference"
                  type="text"
                  icon="el-icon-delete"
                  v-fmtype="'error'"
                  @click.native.stop
                >
                  删除
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="优惠金额" prop="disCountAmount">
          <div class="fm-flex">
            <FmAmount
              :amount="headInfo.commodityRetailDisCountAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="单据金额" prop="commodityRetailAmount">
          <el-input-number
            v-model="headInfo.commodityRetailAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="
              typeof headInfo.commodityRetailTotalAmount == 'string'
                ? Number(headInfo.commodityRetailTotalAmount)
                : headInfo.commodityRetailTotalAmount
            "
            :step="1"
            style="width: 180px"
            @change="changeCommodityRetailAmount"
          ></el-input-number>
        </el-form-item>

        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
          key="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in paperOrderImageList"
            :key="index"
          >
            <el-image
              :id="'paperImage' + index"
              :src="file.url"
              :preview-src-list="paperOrderImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="paperOrderImagePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderImageDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="
              $envConfig.VUE_APP_uploadCustomizePurchaseOrderPaperOrder + ''
            "
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderImageList"
            :show-file-list="false"
            :on-change="paperOrderImageChange"
            :on-success="paperOrderImageSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>

        <div v-if="headInfo.extFieldValueAddNewPojoList.length > 0">
          <div style="height: 10px"></div>
          <el-divider content-position="left">
            <span style="font-weight: bold">拓展字段</span>
          </el-divider>
          <div style="height: 20px"></div>
          <el-row
            v-for="(rowItem, rowFiIndex) in $jsTool.groupArray(
              headInfo.extFieldValueAddNewPojoList,
              3
            )"
            :key="rowFiIndex"
          >
            <el-col :span="8" v-for="(item, fiIndex) in rowItem" :key="fiIndex">
              <el-form-item
                :class="item.visible ? '' : 'deleteFormItem'"
                :label="item.label"
                :required="item.requiredMark && item.visible"
                style="margin-bottom: 10px"
              >
                <span
                  style="color: var(--fm-warning-color)"
                  v-if="!item.visible"
                  >已删除</span
                >
                <template v-else>
                  <template v-if="item.extFieldTypeEnum == 'Input'">
                    <el-input
                      type="text"
                      :placeholder="item.configObj.placeholder"
                      :maxlength="item.configObj.maxlength"
                      v-model="item.value"
                      show-word-limit
                      style="width: 200px"
                    >
                    </el-input>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'InputNumber'">
                    <el-input-number
                      inputWidth="100"
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                      :max="item.configObj.max"
                      :min="item.configObj.min"
                      :step="item.configObj.step"
                      :precision="item.configObj.precision"
                      style="width: 200px"
                    ></el-input-number>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Radio'">
                    <el-radio-group v-model="item.value">
                      <el-radio
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                        style="
                          height: 32px;
                          align-content: space-around;
                          width: 200px;
                        "
                      ></el-radio>
                    </el-radio-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Checkbox'">
                    <el-checkbox-group v-model="item.value">
                      <el-checkbox
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Select'">
                    <el-select
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                    >
                      <el-option
                        v-for="option in item.configObj.list"
                        :key="option.no"
                        :label="option.label"
                        :value="option.label"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'TimePicker'">
                    <el-date-picker
                      v-model="item.value"
                      :type="item.configObj.format"
                      :value-format="
                        item.configObj.format == 'datetime'
                          ? 'yyyy-MM-dd HH:mm:ss'
                          : 'yyyy-MM-dd'
                      "
                      style="width: 200px"
                    >
                    </el-date-picker>
                  </template>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>

        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <CustomizeOrderSelectDialog
      :show="customizeOrderSelectDialogShow"
      :customerId="customer.id"
      from="CustomizePurchaseOrder"
      :selectList="itemList"
      @close="customizeOrderSelectDialogShow = false"
      @selectCustomizeOrder="selectCustomizeOrder"
      v-if="customizeOrderSelectDialogShow"
    >
    </CustomizeOrderSelectDialog>
    <CustomizeOrderItemSelectDialog
      :show="customizeOrderItemSelectDialogShow"
      from="CustomizePurchaseOrder"
      :customizeOrderId="relatedCustomizeOrderHead.id"
      :selectList="itemList"
      @selectCustomizeOrderItem="selectCustomizeOrderItem"
      @close="customizeOrderItemSelectDialogShow = false"
      v-if="customizeOrderItemSelectDialogShow"
    ></CustomizeOrderItemSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizePurchaseOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },

  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(async () => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            await this.getExtFieldList();
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
            this.$refs.editOrderFormRef.validateField("itemQuantity");
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        customerId: this.$ruleUtil.simple({
          fieldName: "客户",
          handleType: "选择",
          required: true,
        }),
        relatedOrderHeadId: this.$ruleUtil.simple({
          fieldName: "定制单",
          handleType: "选择",
          required: true,
        }),
        supplierId: this.$ruleUtil.simple({
          fieldName: "供应商",
          handleType: "选择",
          required: true,
        }),
        totalQuantity: this.$ruleUtil.quantity(
          "商品",
          this.quantityMinLimit,
          1000
        ),

        paperOrderSysFileIdList: this.$ruleUtil.array(
          "纸质单据",
          "上传",
          this.orderConfig.paperOrderRequired ? 1 : 0,
          10
        ),
        saleUserIdList: this.$ruleUtil.array("业务员", "选择", 1),
      };
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        paperOrderRequired: true,
      },

      orderDatePickerShow: false,

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        customerId: null,
        relatedOrderHeadId: null,
        supplierId: null,
        saleUserIdList: [],
        commodityRetailTotalAmount: "0.00",
        commodityRetailDisCountAmount: "0.00",
        commodityRetailAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
        paperOrderSysFileIdList: [],
        remark: "",
        orderParam: "",
        extFieldValueAddNewPojoList: [],
      },
      itemList: [],

      customer: {},
      supplier: {},
      relatedCustomizeOrderHead: {},
      saleUserList: [],
      paperOrderImageList: [],

      customizeOrderSelectDialogShow: false,
      customizeOrderItemSelectDialogShow: false,

      itemQuantityKey: "null",

      quantityMinLimit: 0.001,

      // 拓展字段
      extFieldList: [],
    };
  },

  mounted() {},

  methods: {
    async initOrderData() {
      let userInfo = await this.$storageUtil.getUserInfo();
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.saleUserIdList = [userInfo.id];
      this.saleUserList = [userInfo];
      this.headInfo.extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(this.extFieldList || [])
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizePurchaseOrder:NeedApproval",
        "Order:CustomizePurchaseOrder:PaperOrderRequired",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizePurchaseOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let paperOrderRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizePurchaseOrder:PaperOrderRequired"
        );
        if (
          paperOrderRequiredIndex > -1 &&
          res.data[paperOrderRequiredIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
      }
    },

    async getExtFieldList() {
      let res = await this.$api.extField_findAvailableList(
        "CustomizePurchaseOrder"
      );
      if (res && res.success) {
        this.extFieldList = this.$jsTool.handleExtFiledRes(res.data);
      }
    },

    selectCustomer(item) {
      this.headInfo.customerId = item.id;
      this.customer = item;
      // 清空已选单据
      this.headInfo.relatedOrderHeadId = null;
      this.relatedCustomizeOrderHead = {};
      // 清空已选商品
      this.itemList = [];
      this.selectCustomizeOrderItem([]);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerId");
      });
    },

    selectSupplier(item) {
      this.headInfo.supplierId = item.id;
      this.supplier = item;
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("supplierId");
      });
    },

    toSelectOrder() {
      if (!this.customer || !this.customer.id) {
        this.$message({
          message: "请先选择客户",
          type: "error",
        });
        return;
      }
      this.customizeOrderSelectDialogShow = true;
    },

    selectCustomizeOrder(order) {
      this.headInfo.relatedOrderHeadId = order.id;
      this.relatedCustomizeOrderHead = order;
      this.itemList = [];
      this.selectCustomizeOrderItem([]);
      setTimeout(() => {
        this.toSelectOrderItem();
      }, 200);
    },
    // 选择单据行项目
    async toSelectOrderItem(exist) {
      if (!this.customer || !this.customer.id) {
        this.$message({
          message: "请先选择客户",
          type: "error",
        });
        return;
      }
      if (
        !this.relatedCustomizeOrderHead ||
        !this.relatedCustomizeOrderHead.id
      ) {
        this.$message({
          message: "请先选择定制单",
          type: "error",
        });
        return;
      }
      this.customizeOrderSelectDialogShow = false;
      if (!exist) {
        let getOrderRes = await this.$api.customizeOrder_findVoById(
          this.relatedCustomizeOrderHead.id,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
              text: "加载中...",
            },
          }
        );
        if (getOrderRes && getOrderRes.success) {
          this.handleConstructItemInfo(getOrderRes.data.itemList);
          return;
        }
      }
      this.customizeOrderItemSelectDialogShow = true;
    },
    handleConstructItemInfo(itemList) {
      let res = [];
      for (let index in itemList) {
        let item = itemList[index];
        if (item.toBeInputQuantity <= 0) {
          continue;
        }
        let constructItem = {
          itemNo: index + 1,
          relatedOrderItemId: item.id,
          relatedCustomizeOrderItem: item,
          retailPrice: "0.00",
          itemQuantity: item.toBeInputQuantity,
          commodityRetailTotalAmount: "0.00",
          disCountAmount: "0.00",
          itemAmount: "0.00",
        };
        res.push(constructItem);
      }
      this.selectCustomizeOrderItem(res);
    },

    selectCustomizeOrderItem(list) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      this.itemList = list;
      this.headInfo.commodityRetailTotalAmount = this.$jsTool.sum(
        list.map((d) => d.commodityRetailTotalAmount)
      );
      this.headInfo.commodityRetailDisCountAmount = this.$jsTool.sum(
        list.map((d) => d.disCountAmount)
      );
      this.headInfo.commodityRetailAmount = this.$jsTool.sub(
        this.headInfo.commodityRetailTotalAmount,
        this.headInfo.commodityRetailDisCountAmount
      );
      this.headInfo.orderAmount = this.headInfo.commodityRetailAmount;
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalQuantity");
      });
    },

    changeItemPrice(index, row) {
      if (!row.retailPrice) {
        row.retailPrice = "0.00";
      }
      let itemAmount = this.$jsTool.multi(row.retailPrice, row.itemQuantity);
      row = {
        ...row,
        commodityRetailTotalAmount: itemAmount,
        disCountAmount: 0,
        itemAmount: itemAmount,
      };
      this.$nextTick(() => {
        this.changeItemAfterHandle(index, row);
      });
    },
    changeItemQuantity(index, row, value) {
      if (!value) {
        value = 0;
      }
      if (value == 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.itemList.splice(index, 1);
            this.$nextTick(() => {
              this.changeItemAfterHandle(index);
            });
          })
          .catch(() => {
            row.itemQuantity = 1;
            this.itemQuantityKey = Math.random();
          });
      } else {
        let retailTotalAmount = this.$jsTool.multi(row.retailPrice, value);
        row = {
          ...row,
          itemQuantity: value,
          commodityRetailTotalAmount: retailTotalAmount,
          disCountAmount: 0,
          itemAmount: retailTotalAmount,
        };
        this.$nextTick(() => {
          this.changeItemAfterHandle(index, row);
        });
      }
    },
    changeItemAmount(index, row) {
      if (
        (!row.retailPrice || Number(row.retailPrice) == 0) &&
        (!row.commodityRetailTotalAmount ||
          Number(row.commodityRetailTotalAmount) == 0)
      ) {
        row.disCountAmount = "0.00";
      } else {
        row.disCountAmount = this.$jsTool.sub(
          row.commodityRetailTotalAmount,
          row.itemAmount
        );
      }
      this.changeItemAfterHandle(index, row);
    },
    changeItemAfterHandle(index, row) {
      if (!row) {
        this.selectCustomizeOrderItem(this.itemList);
        return;
      }
      this.itemList.splice(index, 1, row);
      this.selectCustomizeOrderItem(this.itemList);
    },

    // 纸质单据有关
    paperOrderImagePreview(index) {
      document.getElementById("paperImage" + index).click();
    },
    paperOrderImageDelete(index, file) {
      this.paperOrderImageList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageSuccess(res, file, fileList) {
      let index = this.paperOrderImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderImageList.splice(index, 1, {
          ...this.paperOrderImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.paperOrderImageList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },
    // 单据金额
    changeCommodityRetailAmount() {
      this.headInfo = {
        ...this.headInfo,
        commodityRetailDisCountAmount: this.$jsTool.sub(
          this.headInfo.commodityRetailTotalAmount,
          this.headInfo.commodityRetailAmount
        ),
      };
      console.log(
        "a",
        this.headInfo.commodityRetailAmount,
        this.headInfo.commodityRetailTotalAmount
      );
      // 单据优惠比例
      let disCountRadio = this.$jsTool.divis(
        this.headInfo.commodityRetailDisCountAmount,
        this.headInfo.commodityRetailTotalAmount,
        8
      );
      this.itemList.forEach((item, index) => {
        let curIndex = this.itemList.findIndex((d) => d.itemNo == item.itemNo);
        let disCountAmount = 0;
        if (index == this.itemList.length - 1) {
          disCountAmount = this.$jsTool.sub(
            this.headInfo.commodityRetailDisCountAmount,
            this.$jsTool.sum(
              this.itemList
                .filter((d) => d.itemNo != item.itemNo)
                .map((f) => f.disCountAmount)
            )
          );
        } else {
          disCountAmount = this.$jsTool.multi(
            disCountRadio,
            item.commodityRetailTotalAmount
          );
        }
        this.itemList.splice(curIndex, 1, {
          ...this.itemList[curIndex],
          itemAmount: this.$jsTool.sub(
            item.commodityRetailTotalAmount,
            disCountAmount
          ),
          disCountAmount: disCountAmount,
        });
      });
      this.selectCustomizeOrderItem(this.itemList);
    },

    async getOrderInfo(args) {
      let res = await this.$api.customizePurchaseOrder_findVoById(
        this.orderId,
        {
          showLoading: true,
          loadingParam: {
            target: "#editDialog > *",
            lock: true,
          },
          ...args,
        }
      );
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          remark: res.data.head.remark || "",
          paperOrderSysFileIdList: res.data.head.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
          fundPayProgressEnum: res.data.head.fundPayProgressEnum.Name,
          commodityInputProgressEnum:
            res.data.head.commodityInputProgressEnum.Name,
          saleUserIdList: res.data.head.saleUserList.map((d) => d.userId),
          extFieldValueAddNewPojoList: [],
        };
        this.itemList = res.data.itemList;
        this.customer = res.data.head.customer;
        this.saleUserList = res.data.head.saleUserList.map((d) => d.user);
        this.supplier = res.data.head.supplier;
        this.relatedCustomizeOrderHead =
          res.data.head.relatedCustomizeOrderHead;

        this.paperOrderImageList = res.data.head.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );

        // 拓展字段
        let extFieldValueAddNewPojoList = [];
        for (let extFieldItem of this.extFieldList) {
          let value = extFieldItem.value;
          if (
            res.data.head.extFieldValueList &&
            res.data.head.extFieldValueList.length > 0
          ) {
            let extFieldValueAddNewIndex =
              res.data.head.extFieldValueList.findIndex(
                (d) => d.code == extFieldItem.code
              );
            let extFieldValueAddNewItem =
              res.data.head.extFieldValueList[extFieldValueAddNewIndex];
            if (extFieldValueAddNewIndex > -1) {
              value =
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum.Name ||
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum
                  ? extFieldValueAddNewItem.value
                  : null;
              if (
                extFieldItem.extFieldTypeEnum == "Checkbox" ||
                extFieldItem.extFieldTypeEnum.Name == "Checkbox"
              ) {
                if (value) {
                  if (typeof value == "string") {
                    value = value.split(",");
                  }
                } else {
                  value = [];
                }
              }
            }
          }
          extFieldValueAddNewPojoList.push({
            ...JSON.parse(JSON.stringify(extFieldItem)),
            value: value,
          });
        }
        this.headInfo.extFieldValueAddNewPojoList = extFieldValueAddNewPojoList;
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.clearValidate();
        });
      }
    },

    edit(submit) {
      //  校验拓展字段是否填写
      for (let item of this.headInfo.extFieldValueAddNewPojoList) {
        if (item.requiredMark && item.visible && item.value == null) {
          this.$message({
            message: "请完善拓展字段 " + item.label,
            type: "error",
          });
          return;
        }
      }
      let extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(
          this.headInfo.extFieldValueAddNewPojoList.filter((d) => d.visible)
        )
      );
      for (let item of extFieldValueAddNewPojoList) {
        if (item.extFieldTypeEnum == "Checkbox" && item.value) {
          item.value = item.value.toString();
        }
        item.extFieldId = item.id;
      }
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.customizePurchaseOrder_updateAndSubmit(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.customizePurchaseOrder_update(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.customizePurchaseOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.customizePurchaseOrder_saveIntoDraft(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },

    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizePurchaseOrderEditDialog.vue